<app-self-checkin kind="event" [targetId]="targetId"></app-self-checkin>
